import { render, staticRenderFns } from "./ExpressOrderShow.vue?vue&type=template&id=26400b38&scoped=true"
import script from "./ExpressOrderShow.vue?vue&type=script&lang=js"
export * from "./ExpressOrderShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26400b38",
  null
  
)

export default component.exports